import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { CarSubModelNodeFragmentDoc } from './carSubModelNode.generated';
export type CarNodeFragment = { __typename?: 'CarNode', id: string, creationTime?: any | null, updateTime?: any | null, creationYear: number, number: string, frameSerialNumber?: string | null, km?: number | null, color?: string | null, licenceExpDate?: any | null, insuranceExpDate?: any | null, lastCheckInTime?: any | null, rentalTime?: any | null, purchaseTime?: any | null, saleTime?: any | null, salePrice?: number | null, notes?: string | null, damages?: string | null, parkingLocation?: string | null, insuranceCompanyName?: string | null, status: Types.CarCarStatusChoices, vehicleCode?: string | null, importerDiscount?: number | null, serviceProvider?: Types.CarCarServiceProviderChoices | null, carSubModel: { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null, brand: { __typename?: 'BrandNode', id: string, name: string } } }, driver?: { __typename?: 'DriverNode', id: string, name: string, email?: string | null, idNumber?: string | null, customer: { __typename?: 'CustomerNode', name: string, email?: string | null } } | null, bank?: { __typename?: 'BankNode', id: string, name: string } | null, activeDeal?: { __typename?: 'DealNode', id: string } | null };

export const CarNodeFragmentDoc = gql`
    fragment CarNode on CarNode {
  id
  creationTime
  updateTime
  carSubModel {
    ...CarSubModelNode
  }
  creationYear
  number
  frameSerialNumber
  km
  color
  licenceExpDate
  insuranceExpDate
  lastCheckInTime
  rentalTime
  purchaseTime
  saleTime
  salePrice
  notes
  damages
  parkingLocation
  insuranceCompanyName
  status
  vehicleCode
  importerDiscount
  serviceProvider
  driver {
    id
    name
    email
    idNumber
    customer {
      name
      email
    }
  }
  bank {
    id
    name
  }
  activeDeal {
    id
  }
}
    ${CarSubModelNodeFragmentDoc}`;